import React from 'react';

import { ChildrenPropType } from '../../../../../prop-types/children';

import style from './configure-return-shipment.module.less';

export const ConfigureReturnShipmentFormFooter = ({ children }) => {
  return <div className={style.footer}>{children}</div>;
};

ConfigureReturnShipmentFormFooter.propTypes = {
  children: ChildrenPropType.isRequired,
};
